import * as actionTypes from '../../actions/action-types.js'
import { isTrialAccount } from 'helpers/account.js'
import { generateAssets } from 'helpers/fake-assets.js'
const initialState = {
    lastFetch: 0,
    loading: false,
}
const assets = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STORE_INIT:
            return {
                ...initialState,
            }
        case actionTypes.FD_ASS_REQUEST_SUCCESS:
            try {
                if (action?.data?.items?.length > 0) {
                    return {
                        ...state,
                        loading: false,
                        lastFetch: Date.now(),
                        data: action.data,
                    }
                } else {
                    if (isTrialAccount(action?.account)) {
                        return {
                            loading: false,
                            lastFetch: Date.now(),
                            data: {
                                items: generateAssets(action?.account?.farms?.data?.items[0]),
                            },
                        }
                    } else {
                        return {
                            ...state,
                            loading: false,
                            lastFetch: Date.now(),
                            data: action.data,
                        }
                    }
                }
            } catch (err) {
                console.error(err)
                return {
                    ...state,
                    loading: false,
                    lastFetch: Date.now(),
                    data: action.data,
                }
            }
        case actionTypes.FD_ASS_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.FD_ASS_REQUEST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
                lastError: Date.now(),
            }
        case actionTypes.FD_ASS_CACHE:
            return state
        case actionTypes.FD_ASS_FAKE: {
            const farm = action?.account?.farms?.data?.items[0]
            if (farm) {
                return {
                    loading: false,
                    lastFetch: 0,
                    data: {
                        items: generateAssets(farm),
                    },
                }
            } else {
                return {
                    loading: false,
                    lastFetch: 0,
                    data: {
                        items: [],
                    },
                }
            }
        }

        default: {
            return state
        }
    }
}

export default assets
